import {
	USER_STATUS_FAILED,
	USER_STATUS_INITIALIZE,
	USER_STATUS_SAVED,
	USER_STATUS_SAVING,
} from "../actions/types";

const initialState = {
	isSaving: false,
	isSaved: false,
	isSavingFailed: false,
	status: {},
	image: {},
	actingOfficeHierarchy: [],
};
export default function (state = initialState, action) {
	switch (action.type) {
		case USER_STATUS_INITIALIZE:
			return {
				...state,
				isSaving: false,
				isSaved: false,
				isInitialized: true,
				isSavingFailed: false,
				status: action.payload.status,
				image: action.payload.image,
				actingOfficeHierarchy: action.payload.actingOfficeHierarchy,
			};
		case USER_STATUS_SAVING:
			return {
				...state,
				isSaving: true,
				isSaved: false,
				isSavingFailed: false,
			};
		case USER_STATUS_SAVED:
			return {
				...state,
				isSaving: false,
				isSaved: true,
				isSavingFailed: false,
				status: action.payload.status,
				image: action.payload.image,
			};
		case USER_STATUS_FAILED:
			return {
				...state,
				isSaving: false,
				isSaved: false,
				isSavingFailed: true,
			};

		default:
			return state;
	}
}
